(function () {

    var controller = function ($scope, tuxFabMenuEvents, $mdDialog, $window, vehicleDefinitionService, quoteIntegrationConstants, erateSessionVarsService) {
        $scope.group = -1;
        $scope.hasAlerted = false;
        $scope.showPFTab = false;
        $scope.isGroup = function (checkGroup) {
            return ($scope.group === checkGroup);
        };
        // modelYearsResolved var tells us if data has loaded to show Fab menu inputs - otherwise evaluteas to false and 'loading' shows on Fab
        $scope.modelYearsResolved = function(){
            if (erateSessionVarsService.getQuotingMode() == quoteIntegrationConstants.menuQuoteIntegrated){
                return vehicleDefinitionService.modelYearsResolved;
            } else {
                return true;
            }
        }

        var setGroup = function ($event, setGroup) {
            if($scope.group === -1) {
                // This event is fired when the FAB menu is initially opened.
                $scope.$broadcast(tuxFabMenuEvents.shown, setGroup);
            }
            else if ($scope.group != setGroup && (setGroup === 1 || setGroup === 0)){
                $scope.$broadcast(tuxFabMenuEvents.changeVehicle, setGroup);
            }
            if( $scope.group === setGroup){
                // If the current selection is already open, we're going to close the fab.
                $scope.$broadcast(tuxFabMenuEvents.closed,{});
                if ($event) {
                    $event.stopPropagation();
                }
                return;
            }
            $scope.group = setGroup;
            $scope.show = setGroup !== -1 ? true : false;

            if ($event) {
                $event.stopPropagation();
            }
        };
        
        $scope.setGroup = setGroup;
        var closeGroup = function () {
            if(!$scope.fabMenu.$valid && !$scope.hasAlerted) {
                $scope.submitted = true;
                showDialog();
            } else {
                $scope.hasAlerted = false;
                setGroup(null, -1);
            }
        };
        $scope.closeGroup = closeGroup;
        $scope.$on(tuxFabMenuEvents.closed, function () {
            closeGroup();
        });

        $scope.vehicleDefinitionService = vehicleDefinitionService;

        function showDialog() {
            $scope.displayingAlertInvalid = true;
            alert = $mdDialog.alert()
                .title('Invalid or incomplete required fields.')
                .content('Please correct all highlighted fields to continue.')
                .ok('Ok');
            $mdDialog
                .show( alert )
                .finally(function() {
                    $scope.displayingAlertInvalid = false;
                    $scope.hasAlerted = true;
                    alert = undefined;
                });
        }

        $scope.$on("SHOW-PF-TAB", function(eve, show) {
            $scope.showPFTab = show;
        });

        $scope.$on("OPEN-TAB-GROUP", function(eve, args) {
            var gIndex = args.groupIndex;
            if (gIndex != undefined && gIndex > -1) setGroup(eve, gIndex);
        });
        
        $scope.init = function(){
            var quoteIntegrated = $window.sessionStorage.getItem('SESS_QUOTE_MODE');
            var vehicleType = $window.sessionStorage.getItem('SESS_DEALER_VEHICLE_TYPE');
            var autoElig = vehicleType && vehicleType.indexOf('AUTO') >= 0;

            if (quoteIntegrated && quoteIntegrated === 'MENUPRO_INTEGRATED_QUOTE'){ //are we quote integrated?
                var quotePrefill = JSON.parse($window.sessionStorage.getItem('SESS_INTEGRATION_PREFILL'));
                var quoteCount = quotePrefill.productsToQuote.length;
                var foundQuoteId = false;
                for (var i = 0; i < quoteCount && !foundQuoteId; i++){
                    var prodToQuote = quotePrefill.productsToQuote[i];
                    if (prodToQuote && prodToQuote.internalQuoteId != null && prodToQuote.internalQuoteId.length > 0){
                        foundQuoteId = true;
                    }
                }
                if (quotePrefill
                    && quotePrefill.quoteRequiredFields
                    && angular.isArray(quotePrefill.quoteRequiredFields)
                    && quotePrefill.quoteRequiredFields.length > 0
                    && !foundQuoteId){
                    setGroup(null, (autoElig ? 1 : 0));//default to auto
                }
            }
        }

        $scope.init();

        
    };
    taillightUx.directive('tuxFabMenu', ['$window', function($window) {

        return {
            templateUrl: 'assets/components/tlc-fab-menu/tlc-fab-menu.html',
            transclude: false,
            restrict: 'E',
            controller: ['$scope', 'tuxFabMenuEvents', '$mdDialog', '$window', 'vehicleDefinitionService', 'quoteIntegrationConstants', 'erateSessionVarsService', controller],
            scope: {
                show: "=",
                closeFabMenu: "&"
            },
            link: function($scope, element) {
                element.on('click', 'input', function(e){
                    this.select();
                });
            }
        }
    }]);

})();
